import React, { Component, Fragment } from "react";
import I18N from "../../I18N";
import {
  init,
  startLiveBroadcast,
  stopLiveBroadcast,
  getAvailableMics,
  mute,
  unmute,
  getPublisher,
  setCommentatorDelay,
  setMainVolume
} from "../../services/live-production-api";

import NoSleep from "nosleep.js";

import {
  SuccessButton,
  Loader,
  SocialSharePanel,
  ConfirmModal,
  Input
} from "@myplay/ui";

import all from "@myplay/all";

import TeamMemberCard from "../../compenents/TeamMemberCard/TeamMemberCard";
import AudioCheckWizard from "../../compenents/AudioCheckWizard/AudioCheckWizard";

import micIcon from "../../assets/icons/microphone.svg";
import Logo from "../../assets/logos/logo-name.png";

import "./commentary.scss";
import { getAwayTeam, setAwayTeam } from "../../utils/awayTeamHandler";
import isIOS from "../../utils/isIOS";

import defaultLogo from "../../assets/logos/default-team-logo-basketball.png";
import headsetIcon from "../../assets/icons/headset.svg";

const StartBroadcastButton = ({ isInit, isBroadcasting, volumeLevel }) => {
  console.log(volumeLevel);
  return (
    <button className="start-broadcast-button__oval start-broadcast-button__oval--big ">
      <div className="start-broadcast-button__oval start-broadcast-button__oval--med">
        <div className="start-broadcast-button__oval start-broadcast-button__oval-small">
          <img className="start-broadcast-button__mic-icon" src={micIcon} />
        </div>
        <div
          className="start-broadcast-button__oval start-broadcast-button__oval--volume-level"
          style={{
            width: `${74 + 34 * volumeLevel}px`,
            height: `${74 + 34 * volumeLevel}px`
          }}
        />
      </div>
    </button>
  );
};

const EmptyTeamSkeleton = () => {
  return Array(8)
    .fill()
    .map((val, index) => (
      <div key={index} className="empty-team-skeleton">
        <div className="empty-team-skeleton__plus">+</div>
      </div>
    ));
};

const TeamSection = ({ title, team, handleCardEdit, isEditable }) => {
  const { teamImage, members } = team || {};
  return (
    <div className="team-section">
      <img className="team-section__team-logo" src={teamImage || defaultLogo} />
      <p className="team-section__team-title">{title}</p>
      <div className="team-section__members-list">
        {members && members.length > 0 ? (
          members.map((member, index) => (
            <TeamMemberCard
              key={member.id}
              member={member}
              index={index}
              handleCardEdit={handleCardEdit}
              isEditable={isEditable}
            />
          ))
        ) : (
          <EmptyTeamSkeleton />
        )}
      </div>
    </div>
  );
};

class Commentary extends Component {
  state = {
    mics: [],
    selectedMic: null,
    isBrowserSupported: true,
    audio: null,
    isMuted: false,
    isBroadcasting: false,
    isInit: false,
    homeTeam: { name: "HOME", logo: null, members: [] },
    awayTeam: { name: "AWAY", logo: null, members: [] },
    volumeLevel: 0,
    hasError: false,
    isAskToExit: false,
    isLoading: true,
    errorMessage: null,
    cameraVolume: 0,
    commentaryDelay: 0,
    isSlidersSupported: true
  };

  async componentDidMount() {
    this.noSleep = new NoSleep();
    const self = this;
    const params = new URLSearchParams(location.search); //eslint-disable-line
    // this.noSleep.enable();
    document.addEventListener(
      "click",
      function enableNoSleep() {
        document.removeEventListener("click", enableNoSleep, false);
        self.noSleep.enable();
      },
      false
    );
    this.inviteToken = params.get("token");
    if (this.inviteToken) {
      let homeTeam;

      try {
        // check if the site support volume and delay change, if we get 404, site is supported!
        await setMainVolume(this.inviteToken,1);
      } catch (e) {
        this.setState({isSlidersSupported: false});
      }


      try {
        const isBroadcasting = await init(
          this.inviteToken,
          this.setVolumeLevel
        );
      } catch (e) {
        this.setState({ errorMessage: I18N.t("CONNECTION_ERROR_MESSAGE") });
        console.log(e.message);
      }

      const { liveProduction } = all;
      const { getTeamFromLiveSession } = liveProduction;
      try {
        homeTeam = await getTeamFromLiveSession(this.inviteToken);
      } catch (e) {
        console.log();
      }

      const awayTeam = getAwayTeam(this.inviteToken);

      this.setState({ awayTeam: awayTeam, homeTeam: homeTeam });

      if (isIOS()) {
        if (navigator.userAgent.match("CriOS")) {
          this.setState({
            errorMessage: I18N.t("OPEN_IN_SAFARI"),
            isLoading: false
          });
        } else {
          await navigator.mediaDevices.getUserMedia({ audio: true });
          const mics = await getAvailableMics();
          if (mics.length > 0) {
            self.setState({ mics });
          }
          self.setState({ isLoading: false });
        }
      }

      if (!isIOS()) {
        navigator.permissions
          .query({ name: "microphone" })
          .then(async function(permissionStatus) {
            self.setState({ isLoading: false });
            if (permissionStatus.state === "granted") {
              const mics = await getAvailableMics();
              if (mics.length > 0) {
                self.setState({ mics });
              }
            }
            permissionStatus.onchange = async function() {
              if (this.state === "granted") {
                const mics = await getAvailableMics();
                console.log(mics);
                if (mics.length > 0) {
                  self.setState({ mics });
                }
              }
            };
          });
      }
    } else {
      this.setState({
        isLoading: false,
        errorMessage: I18N.t("MISSING_TOKEN_ERROR_MESSAGE")
      });
    }
  }

  componentWillUnmount() {
    this.noSleep.disable();
  }

  setVolumeLevel = level => {
    this.setState({ volumeLevel: level });
  };

  handleTeamNameEdit = e => {
    const name = e.target.value;
    const { awayTeam } = this.state;
    awayTeam.name = name;
    setAwayTeam(this.inviteToken, awayTeam);
    this.setState({ awayTeam: awayTeam });
  };

  handleCardEdit = (playerInfo, index) => {
    const { awayTeam } = this.state;
    if (playerInfo === "delete") {
      awayTeam.members.splice(index, 1);
      awayTeam.members.push({});
    } else {
      awayTeam.members[index] = playerInfo;
    }
    setAwayTeam(this.inviteToken, awayTeam);
    this.setState({ awayTeam: awayTeam });
  };

  handleSelectMic = selectedMic => {
    this.setState({ selectedMic }, () => this.startStopBroadcast());
  };

  toggleMute = () => {
    this.state.isMuted ? unmute() : mute();
    this.setState(prevState => ({ isMuted: !prevState.isMuted }));
  };

  setBroadcastState = (isError, isSuccess) => {
    this.setState({
      isInit: false,
      isBroadcasting: isSuccess,
      hasError: isError
    });
    if (isError) {
      setTimeout(() => {
        this.setState({ hasError: false });
      }, 3000);
    }
  };

  startStopBroadcast = () => {
    const { isBroadcasting, selectedMic } = this.state;
    const publisher = getPublisher();
    publisher.setAudioSource(selectedMic);
    this.setState({ isInit: true });
    isBroadcasting
      ? stopLiveBroadcast(this.inviteToken, this.setBroadcastState)
      : startLiveBroadcast(this.inviteToken, this.setBroadcastState);
  };

  handleChangeCameraVolume = async e => {
    this.setState({ cameraVolume: e.target.value });
  };

  handleSelectVolume = async e => {
    await setMainVolume(this.inviteToken, parseFloat(e.target.value));
  };

  handleChangeCommentaryDelay = async e => {
    this.setState({ commentaryDelay: e.target.value });

  };

  handleSelectDelay = async e => {
    console.log(parseFloat(e.target.value));
    await setCommentatorDelay(this.inviteToken, parseInt(e.target.value));
  };

  render() {
    const {
      mics,
      selectedMic,
      isMuted,
      isBroadcasting,
      isInit,
      homeTeam,
      awayTeam,
      volumeLevel,
      hasError,
      isAskToExit,
      isLoading,
      errorMessage,
      cameraVolume,
      commentaryDelay,
      isSlidersSupported
    } = this.state;
    return (
      <div className="commentary">
        <div className="commentary__content-container">
          {isLoading ? (
            <div className="commentary__main-loader">
              <p>{I18N.t("LOADING")}</p>
              <Loader type="cylon" />
            </div>
          ) : (
            <Fragment>
              <TeamSection title={I18N.t("HOME")} team={homeTeam} />
              {errorMessage ? (
                <div className="commentary__error-message">
                  <img src={headsetIcon} style={{ width: "95px" }} />
                  <p>{errorMessage}</p>
                  {errorMessage !== I18N.t("OPEN_IN_SAFARI") && (
                    <p>{I18N.t("IS_VALID_INVITE")}</p>
                  )}
                </div>
              ) : (
                <div className="commentary__audio-panel">
                  {!selectedMic ? (
                    <AudioCheckWizard
                      mics={mics}
                      handleSelectMic={this.handleSelectMic}
                    />
                  ) : (
                    <div className="commentary__main-panel">
                      <p className="commentary__team-names">
                        {homeTeam && homeTeam.name} <br />{" "}
                        <span style={{ color: "#16c4ab", margin: "5px" }}>
                          vs
                        </span>{" "}
                        <br />{" "}
                        <Input
                          placeholder={I18N.t("AWAY_TEAM")}
                          className="commentary__away-team-input"
                          onBlur={this.handleTeamNameEdit}
                          defaultValue={awayTeam.name}
                          onKeyDown={e => {e.key === "Enter" ? this.handleTeamNameEdit(e) : null; }}//eslint-disable-line

                        />
                      </p>
                      <p className="commentary__live-title">{I18N.t("LIVE")}</p>
                      <div className="commentary__buttons-wrapper">
                        {isInit ? (
                          <div className="commentary__loader">
                            <p>{I18N.t("STARTING_BROADCAST")}</p>
                            <Loader type="cylon" />
                          </div>
                        ) : (
                          <Fragment>
                            <StartBroadcastButton
                              isInit={isInit}
                              isBroadcasting={isBroadcasting}
                              volumeLevel={volumeLevel}
                            />
                            {hasError && (
                              <p className="commentary__error-message">
                                {I18N.t("ERROR_MESSAGE")}
                              </p>
                            )}
                            {isBroadcasting && (
                              <div className="commentary__broadcasting-panel">
                                {isSlidersSupported && <div className="commentary__slider">
                                  <label for="volume">Camera Volume</label>
                                  <input
                                    type="range"
                                    orient="vertical"
                                    id="volume"
                                    min={0}
                                    max={1}
                                    step={0.1}
                                    value={cameraVolume}
                                    onChange={this.handleChangeCameraVolume}
                                    onMouseUp={this.handleSelectVolume}
                                    onTouchEnd={this.handleSelectVolume}
                                  />
                                </div>}
                                <div>
                                  <SuccessButton
                                    onClick={this.toggleMute}
                                    style={{ width: "77px", height: "26px" }}
                                  >
                                    {isMuted
                                      ? I18N.t("UNMUTE")
                                      : I18N.t("MUTE")}
                                  </SuccessButton>
                                  <p
                                    className="commentary__exit-button"
                                    onClick={() => {
                                      this.setState({ isAskToExit: true });
                                    }}
                                  >
                                    {I18N.t("EXIT_COMMENTARY")}
                                  </p>
                                </div>
                                {isSlidersSupported && <div className="commentary__slider">
                                  <label htmlFor="delay">
                                    Commentary Delay
                                  </label>
                                  <input
                                    type="range"
                                    orient="vertical"
                                    id="delay"
                                    value={commentaryDelay}
                                    onChange={this.handleChangeCommentaryDelay}
                                    min={0}
                                    max={15000}
                                    step={100}
                                    onMouseUp={this.handleSelectDelay}
                                    onTouchEnd={this.handleSelectDelay}
                                  />
                                  <span>Current delay is: {commentaryDelay/1000} sec </span>
                                </div>}
                              </div>
                            )}
                          </Fragment>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              )}
              <TeamSection
                title={I18N.t("AWAY")}
                team={awayTeam}
                handleCardEdit={this.handleCardEdit}
                isEditable={true}
              />
              {isAskToExit && (
                <ConfirmModal
                  title={"Are sure you to stop commentary?"}
                  onApprove={async () => {
                    await stopLiveBroadcast(
                      this.inviteToken,
                      this.setBroadcastState
                    );
                    this.setState({ isAskToExit: false, selectedMic: null });
                  }}
                  onDismiss={() => {
                    this.setState({ isAskToExit: false });
                  }}
                />
              )}
            </Fragment>
          )}
        </div>
        <div className="commentary__logo-container">
          <p>{I18N.t("POWERED_BY")}</p>
          <img src={Logo} />
        </div>
      </div>
    );
  }
}

export default Commentary;
